import { ShieldCheck, BadgeCheck, FileLock2, CheckCircle2 } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const POINT_ICONS = [BadgeCheck, FileLock2, CheckCircle2, ShieldCheck];

export const TrustBar = () => {
  const { t } = useLang();
  const tb = t.trustbar;
  return (
    <section className="relative border-y border-[var(--line)] bg-[rgba(8,12,22,0.55)]" data-testid="trust-bar">
      <div className="mx-auto max-w-7xl px-5 py-7">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
          <div className="shrink-0">
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--muted-2)]">{tb.label}</span>
            <div className="mt-2.5 flex flex-wrap gap-2">
              {tb.industries.map((ind) => (
                <span key={ind} className="cell !text-[var(--white)]" data-testid="trust-industry">{ind}</span>
              ))}
            </div>
          </div>
          <div className="hidden lg:block h-12 w-px bg-[var(--line)]" />
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-3 flex-1">
            {tb.points.map((pt, i) => {
              const Icon = POINT_ICONS[i] || CheckCircle2;
              return (
                <div key={pt} className="flex items-center gap-2.5 text-sm text-white/90" data-testid={`trust-point-${i}`}>
                  <Icon size={16} className="text-[var(--green)] shrink-0" /> {pt}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
